import { DataFormats } from '@skylab-shared/constants';
import { L10nBase } from '@skylab-shared/core';
import { AggregatedEmailStatusCode, EmailDeliveryStatus, EmailDeliveryStatusCode, EnumTranslatorBase } from '@skylab-shared/dataModel';
// import { DateFormatBase } from '@skylab-shared/scenes';

interface EmailStatusItem {
    aggregatedEmailStatusCode: AggregatedEmailStatusCode;
    emailStatuses?: EmailDeliveryStatus[];
}

export class EmailStatusDescriptorServiceBase {
    public constructor(
        private readonly enumTranslator: EnumTranslatorBase,
        private readonly l10n: L10nBase,
        private readonly datePipe: any
    ) {}

    public getEmailStatus(entity: EmailStatusItem): string {
        const message = entity.aggregatedEmailStatusCode === AggregatedEmailStatusCode.Unsent
            ? this.l10n._T('business.email-status-descriptor.status.not-sent')
            : this.l10n._T('business.email-status-descriptor.status.mailing-status');
        return [message, entity.emailStatuses?.map(this.createEmailStatusInfo, this).join(', ')].filter(Boolean).join(' ');
    }

    private createEmailStatusInfo(status: EmailDeliveryStatus): string {
        const date = this.datePipe.transform(status.updatedAt, DataFormats.date.dayMonthYearDateTime);
        const { label: statusDescription } = this.enumTranslator.getLabeledEnumValue(EmailDeliveryStatusCode, status.status);
        return `${status.recipient} (${date} - ${statusDescription})`;
    }
}
